/**
 * API Tracking
 *
 * @url https://confluence.rakuten-it.com/confluence/display/RMCCXP/%5BWB%5D+Web+blocks+metrics
 */

import { EventType } from './EventType';
import { PostEvent } from './PostEvent';

export async function PostLoadEvent({
	apiEnv = '',
	clientId = '',
	sessionId = '',
	url = '',
	previewQuery = {},
}: {
	apiEnv: string;
	clientId: string;
	sessionId: string;
	url: string;
	previewQuery?: object;
}) {
	return PostEvent({
		environment: apiEnv,
		clientId,
		sessionId,
		url,
		previewQuery,
		eventType: EventType.LOAD,
	});
}

export async function PostHitEvent({
	apiEnv = '',
	clientId = '',
	sessionId = '',
	campaignId = '',
	contentId = '',
	previewQuery = {},
}: {
	apiEnv: string;
	clientId: string;
	sessionId: string;
	campaignId: string;
	contentId: string;
	previewQuery?: object;
}) {
	return PostEvent({
		environment: apiEnv,
		clientId,
		sessionId,
		campaignId,
		contentId,
		previewQuery,
		eventType: EventType.HIT,
	});
}

export async function PostAppearEvent({
	apiEnv = '',
	clientId = '',
	sessionId = '',
	campaignId = '',
	contentId = '',
	previewQuery = {},
}: {
	apiEnv: string;
	clientId: string;
	sessionId: string;
	campaignId: string;
	contentId: string;
	previewQuery?: object;
}) {
	return PostEvent({
		environment: apiEnv,
		clientId,
		sessionId,
		campaignId,
		contentId,
		previewQuery,
		eventType: EventType.VIEW,
	});
}

export async function PostClickEvent({
	apiEnv = '',
	clientId = '',
	sessionId = '',
	campaignId = '',
	contentId = '',
	url = '',
	previewQuery = {},
}: {
	apiEnv: string;
	clientId: string;
	sessionId: string;
	campaignId: string;
	contentId: string;
	url: string;
	previewQuery?: object;
}) {
	return PostEvent({
		environment: apiEnv,
		clientId,
		sessionId,
		campaignId,
		contentId,
		url,
		eventType: EventType.CLICK,
		previewQuery,
	});
}
